var service = function() {
  var inventoryMatchString = function(cartProduct) {
    var s = '';
    var unit = cartProduct.product.container_type;
    var casePart = null;
    var unitPart = null;
    if (cartProduct.case_quantity) {
      if (cartProduct.case_quantity === 1) {
        casePart = '1 case';
      }
      else {
        casePart = cartProduct.case_quantity + ' cases';
      }
    }
    if (cartProduct.unit_quantity) {
      if (cartProduct.unit_quantity === 1) {
        unitPart = '1 ' + unit;
      } else {
        unitPart = cartProduct.unit_quantity + ' ' + unit + 's';
      }
    }

    if (cartProduct.case_quantity) {
      s += casePart;
      if (cartProduct.unit_quantity) {
        s += ', ' + unitPart;
      }
    } else {
      s += unitPart;
    }

    return s + ' in cart';
  };

  return {
    inventoryMatchString
  };

};
service.$inject = [];
tiz.service('CartProduct', service);
export default service;
